import type { EvidencePhoto } from '../domain/project';

const MAX_SOURCE_BYTES = 5_000_000;
const MAX_STORED_BYTES = 450_000;
const MAX_EDGE = 1280;
const allowedTypes = new Set(['image/jpeg','image/png','image/webp']);

function canvasBlob(canvas:HTMLCanvasElement, quality:number) {
  return new Promise<Blob>((resolve,reject)=>canvas.toBlob((blob)=>blob?resolve(blob):reject(new Error('사진을 기기 저장용으로 줄이지 못했어요.')),'image/webp',quality));
}

function blobDataUrl(blob:Blob) {
  return new Promise<string>((resolve,reject)=>{
    const reader=new FileReader();
    reader.onload=()=>typeof reader.result==='string'?resolve(reader.result):reject(new Error('사진을 읽지 못했어요.'));
    reader.onerror=()=>reject(reader.error??new Error('사진을 읽지 못했어요.'));
    reader.readAsDataURL(blob);
  });
}

export async function prepareEvidencePhoto(file:File,itemId:string):Promise<EvidencePhoto> {
  if(!allowedTypes.has(file.type))throw new Error('항목 사진은 JPG, PNG 또는 WebP만 추가할 수 있어요.');
  if(file.size>MAX_SOURCE_BYTES)throw new Error('항목 사진은 5MB 이하로 골라 주세요.');
  const bitmap=await createImageBitmap(file);
  const scale=Math.min(1,MAX_EDGE/Math.max(bitmap.width,bitmap.height));
  const canvas=document.createElement('canvas');
  canvas.width=Math.max(1,Math.round(bitmap.width*scale));
  canvas.height=Math.max(1,Math.round(bitmap.height*scale));
  const context=canvas.getContext('2d');
  if(!context){bitmap.close();throw new Error('사진을 처리할 수 없는 브라우저예요.');}
  context.drawImage(bitmap,0,0,canvas.width,canvas.height);
  bitmap.close();
  let blob=await canvasBlob(canvas,.78);
  if(blob.size>MAX_STORED_BYTES)blob=await canvasBlob(canvas,.58);
  if(blob.size>MAX_STORED_BYTES)blob=await canvasBlob(canvas,.42);
  if(blob.size>MAX_STORED_BYTES)throw new Error('사진이 아직 커요. 항목이 보이는 부분만 다시 찍어 주세요.');
  return {id:crypto.randomUUID(),itemId,name:file.name.slice(0,120)||'항목 사진',mimeType:'image/webp',byteSize:blob.size,dataUrl:await blobDataUrl(blob),createdAt:new Date().toISOString()};
}
